module.exports = __webpack_public_path__ + "static/media/steelpaw-gameplay-3.67351de1.webm";